export let props = [
  'tableData',
  'tableProp',
  'highlightCurrentRow',
  'order',
  'if',
  'selectedData',
  'tableHeight',
  'expand',
  'useSelection',
  'rowStyle',
  'height',
  'border',
  'id',
  'showsummary',
  "hasData", //报表是否有数据
  "tableTitle" ,//报表标题
  "exportCloumnWidth" ,//导出的列宽
];
export let model = {
  defaultExpand: false, // 默认不显示下拉扩展
  hideLevel: [], // 隐藏等级
  minWidthNum: [], // 最小宽度，跟隐藏等级的index索引一致
  propToLabelObj: {},
  currentRow: {},
  tableAutoHeight: 0,
  mergeList:[]  //存放列数据
};
export let computed = {
  // 行样式回调，返回rowStyle属性，可为回调函数或样式object
  rowStyleCb() {
    const defaultCb = (row, rowIndex) => {
      if(row.row.addHeight){
        return {height:'80px'}
      }
      return this.rowStyle || {};
    };
    return typeof this.rowStyle === 'function' ? this.rowStyle : defaultCb;
  },
  // 是否开启多选框
  _useSelection() {
    if (this.useSelection === undefined) {
      return false;
    } else {
      return this.useSelection;
    }
  },
  currentExpand: {
    get() {
      if (this.expand === false) {
        return false;
      }
      if (!this.tableData || !this.tableData.length) {
        return true;
      }
      return this.defaultExpand;
    },
    set(val) {
      this.defaultExpand = val;
    }
  },
  currentSelectedData: {
    get() {
      return this.selectedData;
    },
    set(val) {
      this.$emit('update:selectedData', val);
    }
  },
  tableDataWidhtOrder() {
    let order = this.order || 0;
    let index = +order;
    this.tableData && this.tableData.forEach(item => {
      item.order = ++index;
    });
    return this.tableData;
  },
  newPropToLabel() {
    return this.methods('getPropToLabel');
  }
};
